import { Box, VStack } from "@chakra-ui/react";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import { useMemo } from "react";
import { useIntl } from "react-intl";
import { CenteredContent } from "../../components/CenteredContent";
import { DataHandler } from "../../components/DataHandler";
import { PageLayout } from "../../components/PageLayout";
import { CommunityHallsItem } from "./Item";

/**
 * @typedef {object} Props
 * @property {import("swr").SWRResponse<import("@raiden/library/types/Api/ApiResponse").ApiResponse<import("@raiden/library/types/RentalArea").RentalArea[]>>} rentalAreasResponse
 */
/**
 * @param {Props} props
 */
export function CommunityHalls(props) {
  const { rentalAreasResponse } = props;

  const intl = useIntl();

  const breadcrumbItems = useMemo(() => {
    /** @type {import("../../components/Breadcrumb").BreadcrumbItem[]} */
    const items = [
      {
        title: intl.formatMessage({
          defaultMessage: "Accueil",
        }),
        url: generateFrontPath({ id: "@front.home" }),
      },
      {
        title: intl.formatMessage({
          defaultMessage: "Les salles communales",
        }),
        url: generateFrontPath({ id: "@front.communityHalls" }),
      },
    ];
    return items;
  }, [intl]);

  return (
    <PageLayout
      breadcrumbItems={breadcrumbItems}
      title={intl.formatMessage({
        defaultMessage: "Les salles communales",
      })}>
      <Box px="1rem">
        <CenteredContent>
          <DataHandler swrResponse={rentalAreasResponse}>
            {({ data: rentalAreas }) => (
              <VStack spacing="1rem">
                {rentalAreas.map((rentalArea) => (
                  <CommunityHallsItem
                    key={rentalArea.id}
                    rentalArea={rentalArea}
                  />
                ))}
              </VStack>
            )}
          </DataHandler>
        </CenteredContent>
      </Box>
    </PageLayout>
  );
}
